<template>
  <div class="relative w-full main-page">
    <div class="pt-5 flex items-between client-status-block rounded-lg top relative">
      
      <main class="c-container py-10 prose max-w-none flex flex-col gap-6 overflow-y-scroll scroll-styling">
        <h1>Политика конфиденциальности</h1>

        <p>
          Выполняя регистрацию, вы соглашаетесь на сбор и обработку персональных данных,
          передаваемых и получаемых в ходе пользования единой онлайн платформы
          взаимодействия и общения между участниками и профессионалами в области
          дроновой индустрии.
        </p>
        <p>
          Политика конфиденциальности персональных данных (далее — Политика) действует
          в отношении всей информации, которую Администрация сайта может получить о
          Пользователе во время использования им Сайта, предоставляемого Администрацией
          сайта, а также в ходе исполнения Администрацией сайта любых соглашений и
          договоров с Пользователем.
        </p>

        <h2>1. Общие положения</h2>
        <p>
          1.1. Администрация сайта обрабатывает персональные данные на законной и
          справедливой основе для выполнения возложенных на Администрацию сайта
          законодательством функций, полномочий и обязанностей, осуществления прав и
          законных интересов Администрации сайта и Пользователей.
        </p>
        <p>
          1.2. Использование Сайта, а также его отдельных функций означает
          безоговорочное согласие Пользователя с настоящей Политикой и указанными
          в ней условиями обработки его персональных данных; в случае несогласия
          с этими условиями Пользователь должен воздержаться от использования Сайта.
        </p>

        <h2>2. Обработка и конфиденциальность персональных данных пользователя</h2>
        <p>
          2.1. Настоящая Политика устанавливает обязательства Администрации сайта
          по неразглашению и обеспечению режима защиты конфиденциальности
          персональных данных, которые Пользователь предоставляет при использовании
          Сайта.
        </p>
        <p>
          2.2. Категории персональных данных, которые Администрация сайта может
          собирать: имя, адрес электронной почты, телефон, по желанию реквизиты
          компании.
        </p>
        <p>
          2.3. Политика применима только к информации, обрабатываемой в ходе
          использования Сайта. Администрация сайта не контролирует и не несет
          ответственность за обработку информации сайтами третьих лиц, на которые
          Пользователь может перейти по ссылкам.
        </p>
        <p>
          2.4. Администрация сайта не проверяет достоверность персональных данных,
          но исходит из того, что Пользователь предоставляет достоверные данные и
          поддерживает их в актуальном состоянии.
        </p>

        <h2>3. Цели сбора персональных данных пользователя</h2>
        <p>
          3.1. Администрация сайта собирает и хранит только те данные, которые
          необходимы для предоставления функционала Сайта или исполнения договоров.
        </p>
        <p>
          3.2. Данные обрабатываются в целях предоставления услуг, идентификации,
          выставления счетов, улучшения работы платформы, а также для связи
          с пользователем.
        </p>

        <h2>4. Условия обработки персональных данных</h2>
        <p>
          4.1. Обработка осуществляется без ограничения срока, законными способами,
          в том числе с использованием средств автоматизации.
        </p>
        <p>
          4.2. Персональные данные сохраняются конфиденциальными, кроме случаев
          добровольного предоставления их пользователем для общего доступа.
        </p>
        <p>
          4.3. Администрация сайта обязуется не передавать данные третьим лицам
          ни при каких обстоятельствах.
        </p>

        <h2>5. Изменение и удаление персональных данных</h2>
        <p>
          5.1. Пользователь может изменить или удалить свои данные через личный
          кабинет либо отправив запрос по электронной почте (см. раздел 9).
        </p>

        <h2>6. Меры защиты персональных данных</h2>
        <p>
          6.1. Администрация сайта принимает необходимые технические и
          организационные меры для защиты данных от неправомерного доступа,
          изменения, блокирования, копирования и иных действий третьих лиц.
        </p>

        <h2>7. Разрешение споров</h2>
        <p>
          Порядок разрешения споров осуществляется в досудебном и судебном порядке
          в соответствии с законодательством Республики Казахстан.
        </p>

        <h2>8. Изменение политики конфиденциальности</h2>
        <p>
          Администрация сайта имеет право вносить изменения в Политику. Новая
          редакция вступает в силу с момента её размещения. Действующая версия
          всегда доступна по адресу:
          <a href="https://fpv-rdke.online/privacy-policy" target="_blank">
            https://fpv-rdke.online/privacy-policy
          </a>.
        </p>

        <h2>9. Обратная связь</h2>
        <p>
          Все вопросы и предложения направляйте в Службу поддержки:
          <a href="mailto:info@rdke.kz">info@rdke.kz</a><br />
          либо по адресу: Республика Казахстан, г. Астана, ул. Ауезова, д. 2, н. п. 1
        </p>

        <p class="text-sm text-gray-500">
          Дата публикации: 16.09.2025 г.
        </p>
      </main>

    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.prose :where(h1,h2,h3) {
  color: #111827;
}
.prose a {
  text-decoration: underline;
}
</style>
